import SIcon from '../../NUI/StreamlineIcons/SIcon';
import { cls } from '../../NUI/utils';

export function CardLogo({type}){
	const card = {
		"001": "visa",
		"002": "mastercard",
		"003": "amex"
	}
	const imgSrc = card[type];
	return imgSrc ? <img className="rounded-[2px] border border-solid border-is2-gray-100 w-[40px] mr-3" src={`https://storage.googleapis.com/instant-med-public/${imgSrc}.svg`} border="0" alt={`${imgSrc} logo`}/> : <SIcon name="insurance-card" size="xs" cls="mr-2" bold/>;
}

export function PaymentCard({card, edit, onEdit, clsn }){
	return (
			<div key={card.short+card.name} onClick={onEdit||null} className={cls("border flex items-center rounded-lg w-full border-is-gray-50 py-3 px-4", edit&& "transition-all duration-300 cursor-pointer hover:bg-is2-blue-50", clsn)}>
				<CardLogo type={card?.CC_tok?.cardType} />
				<div className="flex flex-col text-base">
					{card.name}<br/>
					**** **** **** {card.short}
					<small>{!card?.CC_tok?.token && <span className='text-red-600'>This card token is invalid. Please use a different card.</span>}</small>
				</div>
				{edit && <div className="cursor-pointer absolute right-4 h-5"><SIcon name="pencil" size="xxs" bold cls="cursor-pointer text-is2-gray-body"/></div>}
				
			</div>
	);
}
